<template>
  <div class="card-subtitle-preference">
    <span class="w-100 subtitle-current-email">
      {{ $t('currentPaypalEmail') }}
      <b-badge pill v-if="loaded" :class="paypal_info && paypal_info.email_paypal ? 'verified-email' : 'not-verified-email'"> 
        {{ paypal_info && paypal_info.email_paypal ? $t("creator.verified"): $t("creator.notVerified")}}
      </b-badge> 
      <b-skeleton class="skeleton-badge-settings-email" type="badge" v-else></b-skeleton>

    </span>
    <div class="d-flex align-items-center">
      <span class="d-flex align-items-center mt-1" v-if="!is_editing_paypal && loaded" :class="{'mr-05': paypal_info && paypal_info.email_paypal !== ''}"> 
        {{ paypal_info && paypal_info.email_paypal !== '' ? paypal_info.email_paypal : ''}} 
        <feather-icon icon="EditIcon" class="d-block ml-1 text-blue cursor-pointer" size="18" @click="is_editing_paypal = true" v-if="paypal_info.email_paypal.length > 0"></feather-icon>
        <b-link class="text-blue" @click="is_editing_paypal = true" v-else>Añadir email</b-link>
      </span>
      <b-form class="mt-1" @submit.prevent="saveNewEmail" v-else-if="is_editing_paypal && loaded" >
        <validation-observer #default="{ invalid }">
          <validation-provider rules="required|email">
            <b-input-group>
              <b-form-input v-model="email_editable" type="text"></b-form-input>
              <b-input-group-append>
                <b-button variant="blue-button" :disabled="invalid" class="blue-button" @click="saveNewEmail()">Guardar</b-button>
              </b-input-group-append>
            </b-input-group>
          </validation-provider>

        </validation-observer>
      </b-form>
      <b-skeleton class="col-1 m-0 mr-1" v-else></b-skeleton>
    </div>
  </div>
</template>

<script>
import { 
  BBadge,
  BSkeleton,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BForm,
  BLink
} from "bootstrap-vue";
import service_others from '@/services/others';
import { showToast } from "@/libs/utils/others";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: 'updatePaymentPaypal',
  components: {
    BBadge,
    BSkeleton,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BForm,
    BLink,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    paypal_info: {
      type: Object,
      required: true,
    },
    loaded: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      is_editing_paypal: false,
      email_editable: '',
    };
  },
  methods: {
    saveNewEmail() {
      service_others.addEmailPaypal({email_paypal: this.email_editable})
        .then(response => {
          if (response.status >= 400) {
            showToast(this, 'danger', 'CoffeIcon', 'err', 'messageAccountSettingError')
            return;
          }
          showToast(this, 'success', 'CheckCircleIcon','dataUpdated', 'dataSuccess');
          this.$emit('update_paypal_info', response);
          this.is_editing_paypal = false;
        })
    },
  },
  watch: {
    is_editing_paypal(val) {
      if (val) {
        this.email_editable = this.paypal_info.email_paypal || '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.verified-email {
  background: #2f9d76;
  margin-left: 3px;
  font-size: 9.5px;
}
.not-verified-email {
  background: #b41212;
  margin-left: 3px;
  font-size: 9.5px;
}
</style>